var _g, _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_5532_6526)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 14,
    width: 60,
    height: 60,
    rx: 30,
    fill: "#F7F8FA"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.7637 45.9582C48.7062 45.8175 48.6537 45.675 48.6049 45.5309C47.3077 41.6775 49.4543 37.5274 53.3999 36.2626L54.5805 34.3116C55.7217 32.4257 55.0809 29.9933 53.1491 28.878C51.2174 27.7627 48.7267 28.3872 47.5855 30.273L46.4049 32.224C46.4697 32.5567 46.5102 32.8932 46.5277 33.2313C46.7297 37.2683 43.543 40.6992 39.4086 40.8952L31.8648 41.2929C29.3121 40.9536 26.9373 42.63 26.4677 45.1036C26.5535 46.1989 27.1351 47.201 28.0532 47.8367L30.6554 49.3391L28.5449 52.8268C24.8794 52.3095 22.086 49.3529 21.8552 45.7432C21.5856 41.5345 24.8604 37.9105 29.1702 37.6494L39.4039 37.1095C40.623 37.0106 41.6983 36.2951 42.2384 35.2238C41.7833 34.22 41.8527 33.0629 42.4243 32.1182L45.4733 27.0798C47.5922 23.5782 52.2185 22.4176 55.8061 24.4889C59.3937 26.5602 60.5838 31.0779 58.4644 34.5802L55.4154 39.6186C54.8438 40.5633 53.8394 41.1806 52.7196 41.2751C52.0192 42.2538 51.8954 43.5197 52.395 44.61L52.9513 45.7377L48.7637 45.9582Z",
    fill: "url(#paint0_angular_5532_6526)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2368 42.0398C39.2943 42.1805 39.3469 42.323 39.3957 42.467C40.6929 46.3205 38.5462 50.4706 34.6007 51.7354L33.4201 53.6864C32.2789 55.5722 32.9196 58.0047 34.8514 59.12C36.7832 60.2353 39.2739 59.6108 40.4151 57.7249L41.5957 55.774C41.5309 55.4413 41.4904 55.1048 41.4729 54.7667C41.2709 50.7297 44.4575 47.2987 48.592 47.1027L56.1358 46.7051C58.6884 47.0444 61.0632 45.3679 61.5329 42.8944C61.4471 41.7991 60.8655 40.797 59.9473 40.1613L57.3451 38.6589L59.4557 35.1712C63.1212 35.6884 65.9145 38.645 66.1454 42.2548C66.4149 46.4635 63.1401 50.0874 58.8304 50.3486L48.5967 50.8884C47.3775 50.9873 46.3022 51.7029 45.7621 52.7741C46.2172 53.778 46.1479 54.9351 45.5762 55.8797L42.5273 60.9182C40.4083 64.4198 35.7821 65.5804 32.1945 63.5091C28.6069 61.4378 27.4168 56.92 29.5362 53.4177L32.5851 48.3793C33.1568 47.4347 34.1612 46.8174 35.281 46.7229C35.9814 45.7441 36.1051 44.4782 35.6056 43.388L35.0493 42.2603L39.2368 42.0398Z",
    fill: "url(#paint1_angular_5532_6526)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3575 28.3487L42.5924 27.0725C40.4872 23.5609 35.8657 22.3786 32.2706 24.4326C28.6756 26.4867 27.4671 30.999 29.5723 34.5106L30.7238 36.4314L34.6336 36.2253L33.4564 34.2617C32.3225 32.3706 32.9733 29.9409 34.9089 28.8352C36.845 27.7287 39.3334 28.3655 40.4667 30.2562L41.3324 31.6999C41.3622 31.646 41.3926 31.5926 41.4245 31.5399L43.3565 28.3472L43.3575 28.3487Z",
    fill: "url(#paint2_angular_5532_6526)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4266 53.4867L57.2752 51.5659L53.3653 51.772L54.5425 53.7357C55.6765 55.6268 55.0256 58.0565 53.09 59.1622C51.154 60.2686 48.6655 59.6319 47.5322 57.7412L46.6665 56.2975C46.6368 56.3513 46.6063 56.4048 46.5745 56.4574L44.6424 59.6502L45.4075 60.9264C47.5128 64.438 52.1342 65.6203 55.7293 63.5662C59.3244 61.5122 60.5328 56.9999 58.4276 53.4882L58.4266 53.4867Z",
    fill: "url(#paint3_angular_5532_6526)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_5532_6526",
    x: 0,
    y: 0,
    width: 88,
    height: 88,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.85098 0 0 0 0 0.85098 0 0 0 0 0.85098 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5532_6526"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.85098 0 0 0 0 0.85098 0 0 0 0 0.85098 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_5532_6526",
    result: "effect2_dropShadow_5532_6526"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_5532_6526",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_angular_5532_6526",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(41.0843 38.3623) rotate(55.6933) scale(18.032 23.1312)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4CA6E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#447DA3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_angular_5532_6526",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.9163 49.6357) rotate(69.6151) scale(8.69375 6.30608)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B9C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006970"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_angular_5532_6526",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.9438 30.2223) rotate(167.953) scale(8.55109 6.88273)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E17900"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_angular_5532_6526",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(53.0556 57.7758) rotate(-32.6421) scale(8.64941 7.04781)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E84250"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB115B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIcon);
export default __webpack_public_path__ + "static/media/menuIcon.4a676721adf254b7ba0cb6394bb115de.svg";
export { ForwardRef as ReactComponent };